module.exports = __webpack_public_path__ + "img/install_theme_icon_5.07c2be4d.png";